import React, { useState, useEffect } from "react";
import "./CatelogingShare.scss";
import CustomTextField from "../../../TextFiled/Index";
import { CommonAPImain } from "../../../../Utils/API/CommonAPImain/CommonAPImain";
import { Button, CircularProgress, Menu, MenuItem } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { newCustomerAdd } from "../../../../Utils/API/newCustomerAdd/newCustomerAdd";
import { SendAlbum } from "../../../../Utils/API/SendAlbum/SendAlbum";
import Snackbar from "../../../Vuexy/snackbar/Snackbar";
import SnackbarEror from "../../../Vuexy/snackbar/SnackbarEror";

const CatelogingShare = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [companyTypes, setCompanyTypes] = useState([]);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    city: "",
    companyName: "",
    mobile: "",
    email: "",
    InHelloApp: 1,
  });
  const [errorMessages, setErrorMessages] = useState({
    firstName: "",
    lastName: "",
    mobile: "",
    email: "",
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const [snackbarErrorOpen, setSnackbarErrorOpen] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const { pathname } = location;
    setIsLoading(true);
    if (pathname === "/NewCustomer") {
      CommonAPImain("GetCompanyType")
        .then((response) => {
          setIsLoading(false);
          if (response?.Data?.DT) {
            setCompanyTypes(response.Data.DT);
          }
        })
        .finally(() => setIsLoading(false));
    } else if (pathname === "/CatelogingShare") {
      CommonAPImain("GetCustomerList")
        .then((response) => {
          setIsLoading(false);
          if (response.Status === "200") {
            setCustomerData(response.Data.DT);
            setFilteredData(response.Data.DT); // Initially show all customers
          }
        })
        .finally(() => setIsLoading(false));
    } else {
      setIsLoading(false);
    }
  }, [location.pathname]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    setErrorMessages((prevErrors) => ({
      ...prevErrors,
      [name]: value ? "" : prevErrors[name], // Clear the error if value is entered
    }));
  };

  const handleMobileChange = (e) => {
    const value = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters
    if (value.length <= 10) {
      const formatted = value.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
      setFormData((prevData) => ({
        ...prevData,
        mobile: formatted,
      }));
    }

    setErrorMessages((prevErrors) => ({
      ...prevErrors,
      mobile: value ? "" : prevErrors.mobile, // Clear error if value is entered
    }));
  };

  const handleSubmit = () => {
    let valid = true;
    let errors = {
      firstName: "",
      lastName: "",
      mobile: "",
      email: "",
    };

    if (!formData.firstName) {
      errors.firstName = "First Name is required!";
      valid = false;
    }
    if (!formData.lastName) {
      errors.lastName = "Last Name is required!";
      valid = false;
    }
    if (!formData.mobile) {
      errors.mobile = "Mobile Number is required!";
      valid = false;
    }
    if (!formData.email) {
      errors.email = "Email Id is required!";
      valid = false;
    }
    if (!valid) {
      setErrorMessages(errors);
    } else {
      setErrorMessages({});
      let Id = sessionStorage.getItem("catelogAlbumMasterID");
      setIsLoading(true);
      newCustomerAdd(
        "Catelog_SendAlbum_NewCustomer",
        Id,
        formData?.firstName ?? "",
        formData?.lastName ?? "",
        formData?.city ?? "",
        formData?.companyName ?? "",
        formData?.mobile ?? "",
        formData?.email ?? "",
        formData?.companyTypeId ?? "",
        formData?.companyTypeName ?? "",
        formData?.InHelloApp ?? 1
      )
        .then((response) => {
          setIsLoading(false);
          if (response?.Data?.DT[0]?.Msg == "mobileexists") {
            setSnackbarErrorOpen(true);
            setTimeout(() => {
              setSnackbarErrorOpen(false);
            }, 3000);
          } else {
            setSnackbarOpen(true);
            // setTimeout(() => {
            //   setSnackbarOpen(false);
            //   navigate("/Cateloging");
            // }, 3000);
          }
        })
        .finally(() => setIsLoading(false));
    }
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCompanyTypeSelect = (companyType) => {
    setFormData({
      ...formData,
      companyTypeId: companyType.CompanyTypeId,
      companyTypeName: companyType.CompanyTypeName,
    });
    handleMenuClose();
  };

  const handleCheckboxChange = (e) => {
    setFormData((prevData) => ({
      ...prevData,
      InHelloApp: e.target.checked ? 1 : 0,
    }));
  };

  const [customerData, setCustomerData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedUserId, setSelectedUserId] = useState("");
  const [selectedCustomers, setSelectedCustomers] = useState([]);
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    if (value) {
      const filtered = customerData.filter(
        (customer) =>
          customer.UserId.toLowerCase().includes(value.toLowerCase()) ||
          customer.CustomerCode.toLowerCase().includes(value.toLowerCase()) ||
          customer.FLname.toLowerCase().includes(value.toLowerCase()) ||
          customer.Firmname.toLowerCase().includes(value.toLowerCase()) ||
          customer.Firstname?.toLowerCase().includes(value.toLowerCase()) ||
          customer.mobileno?.toLowerCase().includes(value.toLowerCase()) ||
          customer.Lastname?.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredData(filtered);
    } else {
      setFilteredData(customerData); // Show all customers when search is cleared
    }
  };

  const handleSelectCustomerFromList = (userId, customner) => {
    setSelectedUserId(userId);
    setSearchTerm(customner?.Firmname);
    // setFilteredData([]);
  };

  const handleSaveCustomer = () => {
    if (selectedUserId) {
      const customer = customerData.find(
        (c) => c.UserId.toLowerCase() === selectedUserId.toLowerCase()
      );
      if (customer) {
        setSelectedCustomers([customer]);
        setSelectedUserId("");
      }

      setSearchTerm("");
    }
  };

  const handleDeleteCustomer = (customerId) => {
    setSelectedCustomers(
      selectedCustomers.filter((customer) => customer.CustomerId !== customerId)
    );
  };

  const handleSend = () => {
    setIsLoading(true);
    let Id = sessionStorage.getItem("catelogAlbumMasterID");
    SendAlbum(
      "Catelog_SendAlbum",
      Id ?? "",
      selectedCustomers[0]?.CustomerId ?? ""
    ).then((response) => {
      if (response) {
        setIsLoading(false);
        setSnackbarOpen(true);
        setTimeout(() => {
          setSnackbarOpen(false);
          navigate("/Cateloging");
        }, 3000);
      }
    });
  };

  return (
    <div>
      {isLoading && (
        <div className="loader-overlay">
          <CircularProgress className="loadingBarManage" />
        </div>
      )}

      {location.pathname === "/CatelogingShare" && (
        <div>
          <div className="catelog_search_div">
            <CustomTextField
              fullWidth
              customBorderColor="rgba(47, 43, 61, 0.2)"
              borderoutlinedColor="#00CFE8"
              customTextColor="#2F2B3DC7"
              customFontSize="0.8125rem"
              size="small"
              variant="filled"
              value={searchTerm}
              onChange={handleSearch}
              placeholder="Search Customer"
            />
            {/* <datalist id="customer-options" className="dataListShow">
              {filteredData.map((customer) => (
                <option
                  key={customer.CustomerCode}
                  value={customer.UserId}
                  onClick={() =>
                    handleSelectCustomerFromList(customer.UserId, customer)
                  }
                  className="optionDataList"
                >
                  {customer?.TypoLabel}{" "}
                  {customer?.mobileno && ` - ${customer?.mobileno}`}
                </option>
              ))}
            </datalist> */}

            <Button className="catelog_save_btn" onClick={handleSaveCustomer}>
              Save
            </Button>
          </div>
          {selectedCustomers.length > 0 && (
            <div className="selected-customers">
              <h4>Selected Customer</h4>
              <ul>
                {selectedCustomers.map((customer) => (
                  <li key={customer.CustomerId}>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <span style={{ fontSize: "15px", fontWeight: 600 }}>
                        {customer.Firstname} {customer.Lastname} (
                        {customer.CustomerCode})
                      </span>
                      <span style={{ fontSize: "13px" }}>
                        {customer.email1}
                      </span>
                      <span style={{ fontSize: "13px" }}>
                        {customer.mobileno}
                      </span>
                    </div>
                    <button
                      className="delete-button"
                      onClick={() => handleDeleteCustomer(customer.CustomerId)}
                    >
                      Delete
                    </button>
                  </li>
                ))}
              </ul>
              <Button onClick={handleSend} className="catelog_save_btn">
                Send
              </Button>
            </div>
          )}

          {filteredData.length > 0 && (
            <div style={{marginInline: '15px', marginBottom: '50px'}}>
              <p className="Customer_list_view_title">Customer List</p>
              <div className="dataListShow">
                <div style={{ padding: "10px 0px" }}>
                  {filteredData.map((customer) => (
                    <Button
                      key={customer.CustomerId}
                      className="optionDataList"
                      onClick={() =>
                        handleSelectCustomerFromList(customer.UserId, customer)
                      }
                    >
                      <span>{customer?.TypoLabel}</span>
                      <span>
                        {customer?.mobileno && ` - ${customer?.mobileno}`}
                      </span>
                    </Button>
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>
      )}

      {location.pathname === "/NewCustomer" && (
        <div className="newUser_main">
          <CustomTextField
            fullWidth
            name="firstName"
            value={formData.firstName}
            onChange={handleChange}
            customBorderColor="rgba(47, 43, 61, 0.2)"
            borderoutlinedColor="#00CFE8"
            customTextColor="#2F2B3DC7"
            customFontSize="0.8125rem"
            size="small"
            variant="filled"
            placeholder="First Name"
            required
          />
          {errorMessages.firstName && (
            <p className="error-message">{errorMessages.firstName}</p>
          )}

          <CustomTextField
            fullWidth
            name="lastName"
            value={formData.lastName}
            onChange={handleChange}
            customBorderColor="rgba(47, 43, 61, 0.2)"
            borderoutlinedColor="#00CFE8"
            customTextColor="#2F2B3DC7"
            customFontSize="0.8125rem"
            size="small"
            variant="filled"
            placeholder="Last Name"
            required
          />
          {errorMessages.lastName && (
            <p className="error-message">{errorMessages.lastName}</p>
          )}

          <CustomTextField
            fullWidth
            name="city"
            value={formData.city}
            onChange={handleChange}
            customBorderColor="rgba(47, 43, 61, 0.2)"
            borderoutlinedColor="#00CFE8"
            customTextColor="#2F2B3DC7"
            customFontSize="0.8125rem"
            size="small"
            variant="filled"
            placeholder="City"
          />

          <CustomTextField
            fullWidth
            name="companyName"
            value={formData.companyName}
            onChange={handleChange}
            customBorderColor="rgba(47, 43, 61, 0.2)"
            borderoutlinedColor="#00CFE8"
            customTextColor="#2F2B3DC7"
            customFontSize="0.8125rem"
            size="small"
            variant="filled"
            placeholder="Company Name"
          />

          <CustomTextField
            fullWidth
            name="mobile"
            value={formData.mobile}
            onChange={handleMobileChange}
            customBorderColor="rgba(47, 43, 61, 0.2)"
            borderoutlinedColor="#00CFE8"
            customTextColor="#2F2B3DC7"
            customFontSize="0.8125rem"
            size="small"
            variant="filled"
            placeholder="Mobile (000-000-0000)"
            required
            inputProps={{
              maxLength: 12,
              type: "tel",
            }}
          />
          {errorMessages.mobile && (
            <p className="error-message">{errorMessages.mobile}</p>
          )}

          <CustomTextField
            fullWidth
            name="email"
            value={formData.email}
            onChange={handleChange}
            customBorderColor="rgba(47, 43, 61, 0.2)"
            borderoutlinedColor="#00CFE8"
            customTextColor="#2F2B3DC7"
            customFontSize="0.8125rem"
            size="small"
            variant="filled"
            placeholder="Email Id"
            inputProps={{
              type: "email",
            }}
            required
          />
          {errorMessages.email && (
            <p className="error-message">{errorMessages.email}</p>
          )}

          <CustomTextField
            fullWidth
            name="companyType"
            value={formData.companyTypeName || ""}
            customBorderColor="rgba(47, 43, 61, 0.2)"
            borderoutlinedColor="#00CFE8"
            customTextColor="#2F2B3DC7"
            customFontSize="0.8125rem"
            size="small"
            variant="filled"
            placeholder="Company Type"
            required
            onClick={handleMenuOpen}
            inputProps={{
              readOnly: true,
            }}
          />

          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
            PaperProps={{
              style: {
                maxHeight: 300,
                width: "100%",
              },
            }}
          >
            {companyTypes.map((companyType) => (
              <MenuItem
                key={companyType.CompanyTypeId}
                onClick={() => {
                  handleCompanyTypeSelect(companyType);
                  setAnchorEl(null); // Close menu after selection
                }}
              >
                {companyType.CompanyTypeName}
              </MenuItem>
            ))}
          </Menu>
          {errorMessages.companyType && (
            <p className="error-message">{errorMessages.companyType}</p>
          )}
          <label
            style={{
              color: "#aba3a3",
              fontSize: "15px",
              fontWeight: 600,
              marginBlock: "10px",
            }}
          >
            <input
              type="checkbox"
              checked={formData.InHelloApp === 1}
              onChange={handleCheckboxChange}
            />
            Add in Hello Application
          </label>

          <Button
            className="catelog_submit_button"
            variant="contained"
            color="primary"
            onClick={handleSubmit}
          >
            Submit
          </Button>
        </div>
      )}

      <Snackbar message="Send Album Successfully!" open={snackbarOpen} />
      <SnackbarEror message="Mobile Number Exists" open={snackbarErrorOpen} />
    </div>
  );
};

export default CatelogingShare;

// import React, { useState, useEffect } from "react";
// import "./CatelogingShare.scss";
// import CustomTextField from "../../../TextFiled/Index";
// import { CommonAPImain } from "../../../../Utils/API/CommonAPImain/CommonAPImain";
// import { Button, CircularProgress, Menu, MenuItem } from "@mui/material";
// import { useLocation, useNavigate } from "react-router-dom";
// import { newCustomerAdd } from "../../../../Utils/API/newCustomerAdd/newCustomerAdd";
// import { SendAlbum } from "../../../../Utils/API/SendAlbum/SendAlbum";
// import Snackbar from "../../../Vuexy/snackbar/Snackbar";
// import SnackbarEror from "../../../Vuexy/snackbar/SnackbarEror";

// const CatelogingShare = () => {
//   const [isLoading, setIsLoading] = useState(false);
//   const [companyTypes, setCompanyTypes] = useState([]);
//   const [formData, setFormData] = useState({
//     firstName: "",
//     lastName: "",
//     city: "",
//     companyName: "",
//     mobile: "",
//     email: "",
//     InHelloApp: 1,
//   });
//   const [errorMessages, setErrorMessages] = useState({
//     firstName: "",
//     lastName: "",
//     mobile: "",
//     email: "",
//   });
//   const [anchorEl, setAnchorEl] = useState(null);
//   const [snackbarErrorOpen, setSnackbarErrorOpen] = useState(false);

//   const location = useLocation();
//   const navigate = useNavigate();

//   useEffect(() => {
//     const { pathname } = location;
//     setIsLoading(true);
//     if (pathname === "/NewCustomer") {
//       CommonAPImain("GetCompanyType")
//         .then((response) => {
//           setIsLoading(false);
//           if (response?.Data?.DT) {
//             setCompanyTypes(response.Data.DT);
//           }
//         })
//         .finally(() => setIsLoading(false));
//     } else if (pathname === "/CatelogingShare") {
//       CommonAPImain("GetCustomerList")
//         .then((response) => {
//           setIsLoading(false);
//           if (response.Status === "200") {
//             setCustomerData(response.Data.DT);
//           }
//         })
//         .finally(() => setIsLoading(false));
//     } else {
//       setIsLoading(false);
//     }
//   }, [location.pathname]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prevData) => ({
//       ...prevData,
//       [name]: value,
//     }));

//     setErrorMessages((prevErrors) => ({
//       ...prevErrors,
//       [name]: value ? "" : prevErrors[name], // Clear the error if value is entered
//     }));
//   };

//   const handleMobileChange = (e) => {
//     const value = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters
//     if (value.length <= 10) {
//       const formatted = value.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
//       setFormData((prevData) => ({
//         ...prevData,
//         mobile: formatted,
//       }));
//     }

//     setErrorMessages((prevErrors) => ({
//       ...prevErrors,
//       mobile: value ? "" : prevErrors.mobile, // Clear error if value is entered
//     }));
//   };

//   const handleSubmit = () => {
//     let valid = true;
//     let errors = {
//       firstName: "",
//       lastName: "",
//       mobile: "",
//       email: "",
//     };

//     if (!formData.firstName) {
//       errors.firstName = "First Name is required!";
//       valid = false;
//     }
//     if (!formData.lastName) {
//       errors.lastName = "Last Name is required!";
//       valid = false;
//     }
//     if (!formData.mobile) {
//       errors.mobile = "Mobile Number is required!";
//       valid = false;
//     }
//     if (!formData.email) {
//       errors.email = "Email Id is required!";
//       valid = false;
//     }
//     if (!valid) {
//       setErrorMessages(errors);
//     } else {
//       setErrorMessages({});
//       let Id = sessionStorage.getItem("catelogAlbumMasterID");
//       setIsLoading(true);
//       newCustomerAdd(
//         "Catelog_SendAlbum_NewCustomer",
//         Id,
//         formData?.firstName ?? "",
//         formData?.lastName ?? "",
//         formData?.city ?? "",
//         formData?.companyName ?? "",
//         formData?.mobile ?? "",
//         formData?.email ?? "",
//         formData?.companyTypeId ?? "",
//         formData?.companyTypeName ?? "",
//         formData?.InHelloApp ?? 1
//       )
//         .then((response) => {
//           setIsLoading(false);
//           if (response?.Data?.DT[0]?.Msg == "mobileexists") {
//             setSnackbarErrorOpen(true);
//             setTimeout(() => {
//               setSnackbarErrorOpen(false);
//             }, 3000);
//           } else {
//             setSnackbarOpen(true);
//             // setTimeout(() => {
//             //   setSnackbarOpen(false);
//             //   navigate("/Cateloging");
//             // }, 3000);
//           }
//         })
//         .finally(() => setIsLoading(false));
//     }
//   };

//   const handleMenuClose = () => {
//     setAnchorEl(null);
//   };

//   const handleMenuOpen = (event) => {
//     setAnchorEl(event.currentTarget);
//   };

//   const handleCompanyTypeSelect = (companyType) => {
//     setFormData({
//       ...formData,
//       companyTypeId: companyType.CompanyTypeId,
//       companyTypeName: companyType.CompanyTypeName,
//     });
//     handleMenuClose();
//   };

//   const handleCheckboxChange = (e) => {
//     setFormData((prevData) => ({
//       ...prevData,
//       InHelloApp: e.target.checked ? 1 : 0,
//     }));
//   };

//   const [customerData, setCustomerData] = useState([]);
//   const [filteredData, setFilteredData] = useState([]);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [selectedUserId, setSelectedUserId] = useState("");
//   const [selectedCustomers, setSelectedCustomers] = useState([]);
//   const [snackbarOpen, setSnackbarOpen] = useState(false);

//   const handleSearch = (e) => {
//     const value = e.target.value;
//     setSearchTerm(value);
//     if (value) {
//       const filtered = customerData.filter(
//         (customer) =>
//           customer.UserId.toLowerCase().includes(value.toLowerCase()) ||
//           customer.CustomerCode.toLowerCase().includes(value.toLowerCase()) ||
//           customer.FLname.toLowerCase().includes(value.toLowerCase()) ||
//           customer.Firmname.toLowerCase().includes(value.toLowerCase()) ||
//           customer.Firstname?.toLowerCase().includes(value.toLowerCase()) ||
//           customer.mobileno?.toLowerCase().includes(value.toLowerCase()) ||
//           customer.Lastname?.toLowerCase().includes(value.toLowerCase())
//       );
//       setFilteredData(filtered);
//     } else {
//       setFilteredData([]);
//     }
//   };

//   const handleSelectCustomerFromList = (userId, customner) => {
//     setSelectedUserId(userId);
//     setSearchTerm(customner?.Firmname);
//     setFilteredData([]);
//   };

//   const handleSaveCustomer = () => {
//     if (selectedUserId) {
//       const customer = customerData.find(
//         (c) => c.UserId.toLowerCase() === selectedUserId.toLowerCase()
//       );
//       if (customer) {
//         setSelectedCustomers([customer]);
//         setSelectedUserId("");
//       }

//       setSearchTerm("");
//     }
//   };

//   const handleDeleteCustomer = (customerId) => {
//     setSelectedCustomers(
//       selectedCustomers.filter((customer) => customer.CustomerId !== customerId)
//     );
//   };

//   const handleSend = () => {
//     setIsLoading(true);
//     let Id = sessionStorage.getItem("catelogAlbumMasterID");
//     SendAlbum(
//       "Catelog_SendAlbum",
//       Id ?? "",
//       selectedCustomers[0]?.CustomerId ?? ""
//     ).then((response) => {
//       if (response) {
//         setIsLoading(false);
//         setSnackbarOpen(true);
//         setTimeout(() => {
//           setSnackbarOpen(false);
//           navigate("/Cateloging");
//         }, 3000);
//       }
//     });
//   };

//   return (
//     <div>
//       {isLoading && (
//         <div className="loader-overlay">
//           <CircularProgress className="loadingBarManage" />
//         </div>
//       )}

//       {location.pathname === "/CatelogingShare" && (
//         <div>
//           <div className="catelog_search_div">
//             <CustomTextField
//               fullWidth
//               customBorderColor="rgba(47, 43, 61, 0.2)"
//               borderoutlinedColor="#00CFE8"
//               customTextColor="#2F2B3DC7"
//               customFontSize="0.8125rem"
//               size="small"
//               variant="filled"
//               value={searchTerm}
//               onChange={handleSearch}
//               placeholder="Search Customer"
//             />
//             <datalist id="customer-options" className="dataListShow">
//               {filteredData.map((customer) => (
//                 <option
//                   key={customer.CustomerCode}
//                   value={customer.UserId}
//                   onClick={() =>
//                     handleSelectCustomerFromList(customer.UserId, customer)
//                   }
//                   className="optionDataList"
//                 >
//                   {customer?.TypoLabel}{" "}
//                   {customer?.mobileno && ` - ${customer?.mobileno}`}
//                 </option>
//               ))}
//             </datalist>

//             <Button className="catelog_save_btn" onClick={handleSaveCustomer}>
//               Save
//             </Button>
//           </div>
//           {selectedCustomers.length > 0 && (
//             <div className="selected-customers">
//               <h3>Selected Customer</h3>
//               <ul>
//                 {selectedCustomers.map((customer) => (
//                   <li key={customer.CustomerId}>
//                     <div style={{ display: "flex", flexDirection: "column" }}>
//                       <span style={{ fontSize: "15px", fontWeight: 600 }}>
//                         {customer.Firstname} {customer.Lastname} (
//                         {customer.CustomerCode})
//                       </span>
//                       <span style={{ fontSize: "13px" }}>
//                         {customer.email1}
//                       </span>
//                       <span style={{ fontSize: "13px" }}>
//                         {customer.mobileno}
//                       </span>
//                     </div>
//                     <button
//                       className="delete-button"
//                       onClick={() => handleDeleteCustomer(customer.CustomerId)}
//                     >
//                       Delete
//                     </button>
//                   </li>
//                 ))}
//               </ul>
//               <Button onClick={handleSend} className="catelog_save_btn">
//                 Send
//               </Button>
//             </div>
//           )}
//         </div>
//       )}

//       {location.pathname === "/NewCustomer" && (
//         <div className="newUser_main">
//           <CustomTextField
//             fullWidth
//             name="firstName"
//             value={formData.firstName}
//             onChange={handleChange}
//             customBorderColor="rgba(47, 43, 61, 0.2)"
//             borderoutlinedColor="#00CFE8"
//             customTextColor="#2F2B3DC7"
//             customFontSize="0.8125rem"
//             size="small"
//             variant="filled"
//             placeholder="First Name"
//             required
//           />
//           {errorMessages.firstName && (
//             <p className="error-message">{errorMessages.firstName}</p>
//           )}

//           <CustomTextField
//             fullWidth
//             name="lastName"
//             value={formData.lastName}
//             onChange={handleChange}
//             customBorderColor="rgba(47, 43, 61, 0.2)"
//             borderoutlinedColor="#00CFE8"
//             customTextColor="#2F2B3DC7"
//             customFontSize="0.8125rem"
//             size="small"
//             variant="filled"
//             placeholder="Last Name"
//             required
//           />
//           {errorMessages.lastName && (
//             <p className="error-message">{errorMessages.lastName}</p>
//           )}

//           <CustomTextField
//             fullWidth
//             name="city"
//             value={formData.city}
//             onChange={handleChange}
//             customBorderColor="rgba(47, 43, 61, 0.2)"
//             borderoutlinedColor="#00CFE8"
//             customTextColor="#2F2B3DC7"
//             customFontSize="0.8125rem"
//             size="small"
//             variant="filled"
//             placeholder="City"
//           />

//           <CustomTextField
//             fullWidth
//             name="companyName"
//             value={formData.companyName}
//             onChange={handleChange}
//             customBorderColor="rgba(47, 43, 61, 0.2)"
//             borderoutlinedColor="#00CFE8"
//             customTextColor="#2F2B3DC7"
//             customFontSize="0.8125rem"
//             size="small"
//             variant="filled"
//             placeholder="Company Name"
//           />

//           <CustomTextField
//             fullWidth
//             name="mobile"
//             value={formData.mobile}
//             onChange={handleMobileChange}
//             customBorderColor="rgba(47, 43, 61, 0.2)"
//             borderoutlinedColor="#00CFE8"
//             customTextColor="#2F2B3DC7"
//             customFontSize="0.8125rem"
//             size="small"
//             variant="filled"
//             placeholder="Mobile (000-000-0000)"
//             required
//             inputProps={{
//               maxLength: 12,
//               type: "tel",
//             }}
//           />
//           {errorMessages.mobile && (
//             <p className="error-message">{errorMessages.mobile}</p>
//           )}

//           <CustomTextField
//             fullWidth
//             name="email"
//             value={formData.email}
//             onChange={handleChange}
//             customBorderColor="rgba(47, 43, 61, 0.2)"
//             borderoutlinedColor="#00CFE8"
//             customTextColor="#2F2B3DC7"
//             customFontSize="0.8125rem"
//             size="small"
//             variant="filled"
//             placeholder="Email Id"
//             inputProps={{
//               type: "email",
//             }}
//             required
//           />
//           {errorMessages.email && (
//             <p className="error-message">{errorMessages.email}</p>
//           )}

//           <CustomTextField
//             fullWidth
//             name="companyType"
//             value={formData.companyTypeName || ""}
//             customBorderColor="rgba(47, 43, 61, 0.2)"
//             borderoutlinedColor="#00CFE8"
//             customTextColor="#2F2B3DC7"
//             customFontSize="0.8125rem"
//             size="small"
//             variant="filled"
//             placeholder="Company Type"
//             required
//             onClick={handleMenuOpen}
//             inputProps={{
//               readOnly: true,
//             }}
//           />

//           <Menu
//             anchorEl={anchorEl}
//             open={Boolean(anchorEl)}
//             onClose={handleMenuClose}
//             PaperProps={{
//               style: {
//                 maxHeight: 300,
//                 width: "100%",
//               },
//             }}
//           >
//             {companyTypes.map((companyType) => (
//               <MenuItem
//                 key={companyType.CompanyTypeId}
//                 onClick={() => {
//                   handleCompanyTypeSelect(companyType);
//                   setAnchorEl(null); // Close menu after selection
//                 }}
//               >
//                 {companyType.CompanyTypeName}
//               </MenuItem>
//             ))}
//           </Menu>
//           {errorMessages.companyType && (
//             <p className="error-message">{errorMessages.companyType}</p>
//           )}
//           <label
//             style={{
//               color: "#aba3a3",
//               fontSize: "15px",
//               fontWeight: 600,
//               marginBlock: "10px",
//             }}
//           >
//             <input
//               type="checkbox"
//               checked={formData.InHelloApp === 1}
//               onChange={handleCheckboxChange}
//             />
//             Add in Hello Application
//           </label>

//           <Button
//             className="catelog_submit_button"
//             variant="contained"
//             color="primary"
//             onClick={handleSubmit}
//           >
//             Submit
//           </Button>
//         </div>
//       )}

//       <Snackbar message="Send Album Successfully!" open={snackbarOpen} />
//       <SnackbarEror message="Mobile Number Exists" open={snackbarErrorOpen} />
//     </div>
//   );
// };

// export default CatelogingShare;
